import { render, staticRenderFns } from "./ImageBox.vue?vue&type=template&id=03220b1b&scoped=true&"
import script from "./ImageBox.vue?vue&type=script&lang=js&"
export * from "./ImageBox.vue?vue&type=script&lang=js&"
import style0 from "./ImageBox.vue?vue&type=style&index=0&id=03220b1b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03220b1b",
  null
  
)

export default component.exports